import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatNumber } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  me_sfoc: 198, //units: g/kWh
  emo_threshold: 203, //units: g/kWh
  emo_ideal_fuel_used: 73, //metadata to be removed not needed anymore
  emo_total_fuel_used: 80, //metadata to be removed not needed anymore
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  unit = "kg",
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  //data for priority graph - SFOC graph
  const sfoc_value = Number(metadata["me_sfoc"]); //<100 and >400 is not acceptable - g/kWh
  const sfoc_threshold = Number(metadata["emo_threshold"]);
  //data for backup graph - EMO Fuel graph
  const fuel_ideal = Number(metadata["emo_ideal_fuel_used"]);
  const fuel_value = Number(metadata["emo_total_fuel_used"]);

  let ideal, actual, threshold, graphUnits, calcType, barName;
  if (sfoc_value && sfoc_threshold) {
    //SFOC graph
    actual = Number(sfoc_value);
    ideal = sfoc_threshold;
    threshold = sfoc_threshold;
    graphUnits = "g/kWh";
    calcType = "Specific fuel-oil consumption";
    barName = "Actual SFOC";
  } else if (fuel_ideal && fuel_value) {
    //EMO Fuel use graph
    ideal = fuel_value > 1000 ? fuel_ideal / 1000 : fuel_ideal;
    actual =
      fuel_value > 1000
        ? Math.round(fuel_value) / 1000
        : Math.round(fuel_value);
    threshold =
      fuel_value > 1000
        ? Math.round(fuel_ideal) / 1000
        : Math.round(fuel_ideal);
    graphUnits =
      fuel_value > 1000 && unit === "kg"
        ? "tonnes"
        : fuel_value > 1000
          ? `k ${unit}`
          : `${unit}`;
    calcType = "Fuel consumption";
    barName = "Actual fuel";
  } else {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const data = [
    {
      name: barName,
      mobileName: "Actual",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = 0.2 * Number(actual);
  const domainMax =
    actual < ideal
      ? ideal + margin
      : Math.ceil(Number(actual) + Number(margin));
  const domain = [domainMin, domainMax];

  const mobileMargin =
    actual < threshold ? 0.1 * Number(threshold) : 0.1 * Number(actual);
  const mobileDomainMax =
    actual < ideal
      ? ideal + mobileMargin
      : Math.ceil(Number(actual) + Number(mobileMargin));
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Ship-specific threshold${
        !isExample
          ? ` (${
              formatNumber(threshold, {
                unit: graphUnits,
                options: { boundaryValues: [0, actual] },
              }).formattedValue
            })`
          : ""
      }`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < threshold}
      unitOfMeasure={graphUnits !== "%" ? ` ${graphUnits}` : graphUnits}
      axisLabel={`${calcType} (${graphUnits})`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${formatNumber(value, { unit: graphUnits, options: { boundaryValues: [0, threshold] } }).formattedValue}`
      }
      isExample={isExample}
    />
  );
}
